import { render, staticRenderFns } from "./LabExpense.vue?vue&type=template&id=14cd898e&scoped=true"
import script from "./LabExpense.vue?vue&type=script&lang=js"
export * from "./LabExpense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cd898e",
  null
  
)

export default component.exports